// extracted by mini-css-extract-plugin
module.exports = {"root":"CreatePDFLink_root__2ZS0Q","spinner":"CreatePDFLink_spinner__yHOig","downloadContainer":"CreatePDFLink_downloadContainer__uYI99"};